export interface IPosition {
    id: number | null;
    name: string;
}
export type PositionResponseType = {
    id: number;
    name: string;
}
export enum PositionName {
    ADMIN='Администратор',
    COSMETOLOG='Врач-косметолог'
}
